import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

// Current session / this device — cookies identify which session to clear.
export const logoutSingleDevice = createAsyncThunk(
  'master-user/logout-single-device',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${ROOT_URL}/master-user/logout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const result = await response.json().catch(() => ({}));
      // 401 means the session is already gone server-side, which is what logout wants.
      if (!response.ok && response.status !== 401) return rejectWithValue(result);
      return result;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  response: [],
  error: null,
};

const LogoutSingleDevice = createSlice({
  name: 'LogoutOfSingleDevice',
  initialState,
  reducers: {},
  extraReducers: {
    [logoutSingleDevice.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [logoutSingleDevice.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [logoutSingleDevice.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default LogoutSingleDevice;
